/**
 * Mobile navigation panel (ported from New-Man, adapted to the Motornieuws header).
 *
 * - .site-hamburger toggles the full-height panel #site-navigation (`hidden` + aria-expanded),
 *   locks body scroll, closes on Escape and when the viewport grows past the hamburger breakpoint.
 * - Below 992px the top bar is hidden and its three items (search box, top navigation, socials)
 *   are MOVED into the panel slots, so every element (and every ID, e.g. the Search & Filter form)
 *   exists exactly once in the DOM. From 992px up they are moved back into the top bar.
 */
const mobileMenu = () => {
	const $hamburger = document.querySelector('.site-hamburger');
	const $panel = document.getElementById('site-navigation');
	const $header = document.querySelector('.site-header');

	if (!$hamburger || !$panel || !$header) return;

	// Hamburger + panel exist below 1280px (the width where the desktop .nav-block is hidden)
	const panelMq = window.matchMedia('(max-width: 1279.98px)');
	// Top-bar items move into the panel below 992px
	const mobileMq = window.matchMedia('(max-width: 991.98px)');

	const setPanelTop = () => {
		const bottom = Math.max(0, Math.round($header.getBoundingClientRect().bottom));
		$panel.style.setProperty('--mobile-nav-top', `${bottom}px`);
	};

	const setOpen = (open) => {
		if (open) setPanelTop();
		$panel.hidden = !open;
		document.body.classList.toggle('site-nav-open', open);
		document.body.style.overflow = open ? 'hidden' : '';
		$hamburger.setAttribute('aria-expanded', String(open));
	};

	$hamburger.addEventListener('click', () => setOpen($panel.hidden));

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !$panel.hidden) {
			setOpen(false);
			$hamburger.focus();
		}
	});

	panelMq.addEventListener('change', (e) => {
		if (!e.matches && !$panel.hidden) setOpen(false);
	});

	window.addEventListener('resize', () => {
		if (!$panel.hidden) setPanelTop();
	});

	// Move the top-bar items between the top bar and the panel slots
	const items = [...document.querySelectorAll('[data-mobile-nav-item]')].map(($el) => ({
		$el,
		$home: $el.parentNode,
		$next: $el.nextElementSibling,
		$slot: $panel.querySelector(`[data-mobile-nav-slot="${$el.dataset.mobileNavItem}"]`),
	}));

	const placeItems = (mobile) => {
		items.forEach(({ $el, $home, $next, $slot }) => {
			if (!$slot) return;
			if (mobile) {
				if ($el.parentNode !== $slot) $slot.appendChild($el);
			} else if ($el.parentNode !== $home) {
				$home.insertBefore($el, $next && $next.parentNode === $home ? $next : null);
			}
		});
	};

	placeItems(mobileMq.matches);
	mobileMq.addEventListener('change', (e) => placeItems(e.matches));
};

export default mobileMenu;
